module.exports = __webpack_public_path__ + "img/banner-wallet-hen.062d79df.png";